export const subject_fields = [
    {
        value: 0,
        label: '课程&会员'
    },
    {
        value: 1,
        label: '电商'
    }
]

export const default_value = {
    title:'',
    number:  '',
    d_percent:'',
    d_count: 0,
    line_data: [],
    isRise: true
}

export const default_mark_value = {
    title:'',
    num: '',
    percent: '',
    isRise:true,
    toPercent: '',
}